import * as React from 'react';
import { Column } from 'react-data-grid';
import { ChartType, DurationFromType } from 'src/services/graphql/Models';
import uuidv1 from 'uuid/v1';
import * as DataGridAddOns from 'react-data-grid-addons';
import ChartEdit from './ChartEdit';
import ClientName from 'src/container/Client/ClientName';
import './Chart.scss';
import Container from '../Generic/Container';
import SensorTypeName from 'src/container/SensorType/SensorTypeName';

const columns: Array<Column> = [
  {
    key: 'name',
    name: 'Name',
    filterable: true,
    editable: true,
    resizable: true,
    sortable: true,
  },
  {
    key: 'sensorType',
    name: 'Sensor Type',
    filterable: false,
    editable: true,
    resizable: true,
    sortable: true,
    formatter: SensorTypeName
  },
  {
    key: 'chartType',
    name: 'Chart Type',
    filterable: true,
    editable: true,
    resizable: true,
    sortable: true,
    filterRenderer: DataGridAddOns.Filters.AutoCompleteFilter,
  }
];

const superUserColumns = [
    ...columns,
    {
      key: 'clientId',
      name: 'Client',
      filterable: true,
      editable: true,
      resizable: true,
      sortable: true,
      formatter: ClientName
    }
];

function renderEdit({ resolveRow, rejectRow, fromObject, isNew }: any) {
  return (
    <ChartEdit  
      resolveRow={resolveRow}
      rejectRow={rejectRow}
      fromObject={fromObject}
      isNew={isNew}
    />
  );
}

export default Container(
  ({isSuperUser}: any) => {
    if (isSuperUser) {
      return superUserColumns;
    } else {
      return columns;
    }
  }, 
  'charts', 
  renderEdit,
  ({isSuperUser}) => ({
    name: 'Charts',
    icon: 'line chart',
    enableFilter: true,
    enableAddRow: true,
    addRowButtonText: 'Add Chart',
    filterRowsButtonText: 'Filter Chart'
  }),
  ({clientId}) => {
    return {
      clientId: clientId,
      typedId: `ch:${uuidv1()}`,
      chartType: ChartType.line,
      include: [{
        unitIds: [],
        unitSensors: [],
        unitGroups: ['All Units']
      }],
      exclude: [],
      durationFromType: DurationFromType.hour,
      durationFrom: '3',
    };
  },
);


// WEBPACK FOOTER //
// ./src/container/Chart/Chart.tsx